<template>
  <div class="users">
    <span id="u-add-up">
      <UserAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('users.cards.title')">
      <div class="row">
        <div class="flex md12">
          <va-input
            v-model="name"
            :label="$t('users.forms.nameEmailLabel')"
            :placeholder="$t('users.forms.nameEmailPlaceholder')"
          />
        </div>
      </div>
      <template slot="actions">
        <va-button
          @click="open"
          href='#u-add-up'
          icon="fa fa-plus"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="users"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('users.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href='#u-add-up'
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover v-if="props.rowData.id != loggedUserId" :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData.id)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('users.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import UserAddUpdate from './UserAddUpdate'

const perPage = 10
export default {
  name: 'users',
  components: {
    UserAddUpdate,
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (id) {
      this.modalDeletar = true
      this.deleteId = id
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.users.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_user_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      loggedUserId: this.$store.getters['authenticate/user'].id,
      users: [],
      name: '',
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    users: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2, $busca: String! = "%%") {
        users: user(
            limit: $perPage,
            offset: $page,
            where: {_or: [{name: {_ilike: $busca}}, {email: {_ilike: $busca}}]},
            order_by: {id: asc}
          ) {
          id
          name
          email
          role {
            id
            name
          }
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
          busca: this.nameSearch,
        }
      },
    },
    pages: gql`
    query MyQuery {
      pages: user_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    nameSearch () {
      return '%' + this.name.trim() + '%'
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('users.headings.name'),
        width: '35%',
      }, {
        name: 'email',
        title: this.$t('users.headings.email'),
        width: '35%',
      }, {
        name: 'role',
        title: this.$t('users.headings.role'),
        width: '10%',
        callback (value) {
          return value.name
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('users')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.users.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
